<template>
  <div class="ev-digital-event-room" id="ev-digital-event">
    <modal-window></modal-window>
    <router-view></router-view>
  </div>
</template>

<script>
import ModalWindow from "./components/DigitalEvent/common/ModalWindow";
import BaseMixin from "./components/DigitalEvent/mixins/BaseMixin";
import { getThemeColor } from "./helpers/helpers";

export default {
  name: "DigitalEvent",
  mixins: [BaseMixin],
  components: {
    "modal-window": ModalWindow
  },
  methods: {
    /** Parse theme styles */
    _parseThemeStyles() {
      this.$store.commit("setThemeStyles", {
        primaryColor: getThemeColor("--color-primary"),
        secondaryColor: getThemeColor("--color-secondary"),
        tertiaryColor: getThemeColor("--color-tertiary"),
        defaultColor: getThemeColor("--color-default"),
        successColor: getThemeColor("--color-success"),
        warningColor: getThemeColor("--color-warning")
      });
    }
  },
  created() {
    this._parseThemeStyles();
    this.$store.dispatch("config/initEventStartTimer");
  }
};
</script>
